/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteInventoryInCommandResult } from '../../models/delete-inventory-in-command-result';

export interface ApiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Params {
      body?: {
'Id'?: string;
}
}

export function apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryInDeleteInventoryInDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteInventoryInCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteInventoryInCommandResult>;
    })
  );
}

apiNurseryManagerInventoryInDeleteInventoryInDelete$Plain.PATH = '/api/NurseryManager/InventoryIn/DeleteInventoryIn';
